module.exports = __webpack_public_path__ + "img/hr-garballo-07.f6b1e589.png";